/** @format */

import styles from "../../../styles/Components/pricing-plan/individual-services/ReferredUsers.module.css";
import { useSelector } from "react-redux";
import { useRelativeTime } from "../../../hooks/useRelativeTime";
import Avatar from "react-avatar";
import { Skeleton, Tooltip } from "antd";
import { FaCreditCard, FaMoneyBill, FaUserPlus } from "react-icons/fa";
import React, { useState } from "react";
import InviteFriendsModal from "../../mini-app/mini-pricing/InviteFriendsModal";

const ReferredUser = ({ userInfo }) => {
  const {
    addition_reward: earnedCredit,
    createdDate: date,
    cashable_reward: earnedMoney,
    referred_user_avatar: avatar,
    referred_user_email: email,
    referred_user_username: userName,
  } = userInfo;

  const formattedUserName = `${userName?.substring(0, 12)}${
    userName?.length > 12 ? "..." : ""
  }`;

  const joinDate = useRelativeTime(date);

  return (
    <div className={styles.referredUser}>
      <div className={styles.profileImage}>
        {avatar ? (
          <img
            className={styles.profileImg}
            src={avatar}
            alt="profile avatar"
          />
        ) : (
          <Avatar
            name={userName}
            size="100%"
            round={true}
            color="#0c4cfc20"
            fgColor="#0c4cfc"
          />
        )}
      </div>

      <div className={styles.userInfo}>
        <h3>
          <Tooltip title={userName} color="#0c4cfc">
            {formattedUserName}
          </Tooltip>
        </h3>
        <p>{joinDate}</p>

        <div className={styles.earnedBox}>
          <div className={styles.earnedRow}>
            <span className={styles.title}>
              <FaMoneyBill size={12} />
              Earned Money
            </span>
            <span className={styles.earnedValue}>${earnedMoney}</span>
          </div>
          <div className={styles.earnedRow}>
            <span className={styles.title}>
              <FaCreditCard size={12} />
              Earned Credit
            </span>
            <span className={styles.earnedValue}>
              ${(earnedCredit / 100).toFixed(1)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const InviteButton = ({ title, style = {} }) => {
  const [showInviteModal, setShowInviteModal] = useState(false);

  return (
    <>
      <div
        onClick={() => setShowInviteModal(true)}
        className={styles.inviteBtn}
        style={style}
      >
        <FaUserPlus size={20} style={{ marginBottom: "0.4rem" }} />
        {title}
      </div>
      <InviteFriendsModal show={showInviteModal} setShow={setShowInviteModal} />
    </>
  );
};

function ReferredUsers() {
  const {
    pricingPlan: { referralRewardsLoading, referralRewards },
  } = useSelector((state) => state);

  const hasReferred = referralRewards?.length > 0;

  if (referralRewardsLoading)
    return (
      <div className={styles.loaderContainer}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className={styles.loaderItem}>
            <Skeleton.Avatar active />
            <Skeleton.Node active rootClassName={styles.loader} />
          </div>
        ))}
      </div>
    );

  if (!hasReferred)
    return (
      <div className={styles.noReferred}>
        <h5>
          You haven’t invited anyone yet. Invite a friend now and enjoy the
          rewards!
        </h5>
        <InviteButton title="Invite Friends" style={{ width: "100%" }} />
      </div>
    );

  return (
    <div className={styles.referredList}>
      {referralRewards?.map((user) => (
        <ReferredUser
          key={`${user?.referred_user_email}/${user?.createdDate}`}
          userInfo={user}
        />
      ))}
      <InviteButton title="Invite Friends" style={{ width: "100%" }} />
    </div>
  );
}

export default ReferredUsers;
